import licence from "./licence";

export default {
  licence,
};
